import React, { useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { Container } from "react-bootstrap";
import Typography from "@mui/material/Typography";
import { HiOutlineChevronDown } from "react-icons/hi";
import { HiOutlineFilter } from "react-icons/hi";
import { AiFillTag } from "react-icons/ai";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import ModalApp from "../../components/ModalApp";
import SliderRangeFilter from "../../components/Slider";
import Title from "../../components/Title";
import { trackClick } from '../../utils/gtm'
import { tagIdFromLegacySuffix } from '../../utils/marketplaceTagIds'

const BUTTON_LABELS = {
  relevant: 'mais-relevantes',
  discount_desc: 'maiores-descontos',
  smaller: 'menor-preco',
  larger: 'maior-preco',
  label_asc: 'ordem-alfabetica-a-z',
  label_desc: 'ordem-alfabetica-z-a',
};
import { useScreenTracking } from '../../hooks/useScreenTracking';
import { categoryOrBrand } from "../../utils/categoryOrBrand";

import {
  CheckboxContainer,
  Radio,
  ContentBrandsAndCategories,
  ContainerFilter,
  Counter,
  Form,
  Center,
  Line,
  ValueSlider,
} from "./styles";

import { Button } from "react-bootstrap";
// import Offcanvas from 'react-bootstrap/Offcanvas';

import { useSelector, useDispatch } from "react-redux";

import {
  selectBrands,
  counterCheckBrands,
  clearCheckBrand,
  clearCheckCategories,
  setOrder,
  counterCheckCategories,
  selectCategories,
  setRangeSlide,
} from "../../Redux/filterSlice";
import { useApp } from "../../contexts/AppContext";
export default function FilterProducts({
  onClickCategory,
  onClickBrand,
  onClickApplyFilter,
  onClickClearFilter,
  target,
}) {

  const { id } = useParams();
  const [Loading, setLoading] = useState(true);
  const [counter, setCounter] = useState(null);
  const [show, setShow] = useState(false);
  const categories = useSelector(selectCategories);
  const brands = useSelector(selectBrands);
  const brandsCheck = useSelector(counterCheckBrands);
  const categoriesCheck = useSelector(counterCheckCategories);
  const [order, setOrderValue] = useState("relevant");
  const { whitelabel } = useApp();
  const [displayMode, setDisplayMode] = useState(whitelabel?.payment_mode);
  const disp = useDispatch();
  const screenTracking = useScreenTracking()
  const getFilterType = categoryOrBrand(categories, brands);

  useEffect(() => {
    const fetchData = async () => {
      let qtd = target === "Categorias" ? categoriesCheck : brandsCheck;
      setCounter(qtd);
      setLoading(true);
      try {
        setLoading(false);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [show]);

  const handleClose = () => {
    trackClick({
      title: "fechar-filtro",
      contentType: getFilterType,
      screenName: screenTracking,
      tagId: tagIdFromLegacySuffix("05"),
    });

    setShow(false);
  };

  const handleApplyFilters = (e) => {
    trackClick({
      title: "filtrar",
      contentType: getFilterType,
      screenName: screenTracking,
      tagId: tagIdFromLegacySuffix("04"),
    });

    onClickApplyFilter();
    handleClose();
  };

  const handleClearFilter = () => {
    disp(clearCheckBrand());
    disp(clearCheckCategories());
    onClickClearFilter();
  };
  const handleShow = () => {
    const savedOrder = localStorage.getItem("orderFilter") || "relevant";
    setOrderValue(savedOrder);
    setShow(true);

    trackClick({
      title: "abrir-filtro",
      contentType: getFilterType,
      screenName: screenTracking,
      tagId: tagIdFromLegacySuffix("04"),
    });

  };

  const handleOrderChange = (value, reduxValue) => {

    trackClick({
      title: BUTTON_LABELS[value] || value,
      contentType: getFilterType,
      screenName: screenTracking,
      tagId: tagIdFromLegacySuffix("04"),
    });

    setOrderValue(value);
    localStorage.setItem("orderFilter", value);
    disp(setOrder({ order: reduxValue }));
  };

  return (
    !Loading && (
      <>
        <ContainerFilter className="d-flex justify-content-center">
          <button
            type="button"
            className="d-flex btn btn-outline-grey align-items-center"
            onClick={handleShow}
          >
            <HiOutlineFilter color="var(--primary-color)" size="1.1em" />
            <span className="ms-1 fs-6">Filtrar</span>
          </button>
        </ContainerFilter>
        <ModalApp
          show={show}
          //handleModal={() => setShow(false)}
          handleModal={handleClose}
          contentClassName="modal-filter-responsive"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px 20px",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <h2
              style={{
                margin: 0,
                fontSize: "18px",
                fontWeight: "600",
                color: "var(--primary-color)",
              }}
            >
              Filtrar
            </h2>
          </div>

          <div
            style={{
              padding: "20px",
              flex: 1,
              minHeight: 0,
              overflowY: "auto",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <div style={{ marginBottom: "24px" }}>
              <h3
                style={{
                  margin: "0 0 16px 0",
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "var(--primary-color)",
                }}
              >
                Ordenado por
              </h3>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "var(--light-color)",
                  }}
                >
                  <input
                    type="radio"
                    name="order"
                    value="relevant"
                    checked={order === "relevant"}
                    onChange={() => handleOrderChange("relevant", "relevant")}
                    style={{ accentColor: "var(--primary-color)" }}
                  />
                  Mais relevantes
                </label>

                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "var(--light-color)",
                  }}
                >
                  <input
                    type="radio"
                    name="order"
                    value="discount_desc"
                    checked={order === "discount_desc"}
                    onChange={() =>
                      handleOrderChange("discount_desc", "discount_desc")
                    }
                    style={{ accentColor: "var(--primary-color)" }}
                  />
                  Maiores descontos
                </label>

                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "var(--light-color)",
                  }}
                >
                  <input
                    type="radio"
                    name="order"
                    value="smaller"
                    checked={order === "smaller"}
                    onChange={() => handleOrderChange("smaller", "price_asc")}
                    style={{ accentColor: "var(--primary-color)" }}
                  />
                  Menor preço
                </label>

                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "var(--light-color)",
                  }}
                >
                  <input
                    type="radio"
                    name="order"
                    value="larger"
                    checked={order === "larger"}
                    onChange={() => handleOrderChange("larger", "price_desc")}
                    style={{ accentColor: "var(--primary-color)" }}
                  />
                  Maior preço
                </label>

                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "var(--light-color)",
                  }}
                >
                  <input
                    type="radio"
                    name="order"
                    value="label_asc"
                    checked={order === "label_asc"}
                    onChange={() => handleOrderChange("label_asc", "label_asc")}
                    style={{ accentColor: "var(--primary-color)" }}
                  />
                  Ordem alfabética (A - Z)
                </label>

                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "var(--light-color)",
                  }}
                >
                  <input
                    type="radio"
                    name="order"
                    value="label_desc"
                    checked={order === "label_desc"}
                    onChange={() =>
                      handleOrderChange("label_desc", "label_desc")
                    }
                    style={{ accentColor: "var(--primary-color)" }}
                  />
                  Ordem alfabética (Z - A)
                </label>
              </div>
            </div>

            <div
              style={{
                height: "1px",
                backgroundColor: "#e0e0e0",
                margin: "0 0 24px 0",
              }}
            />

            <div style={{ marginBottom: "24px" }}>
              <SliderRangeFilter mode={displayMode} brands={brands} />
            </div>

            <div
              style={{
                height: "1px",
                backgroundColor: "#e0e0e0",
                margin: "0 0 24px 0",
              }}
            />

            {["Marcas", "Produtos"].indexOf(target) >= 0 &&
              brands.length > 0 && (
                <>
                  <div style={{ marginBottom: "24px" }}>
                    <h3
                      style={{
                        margin: "0 0 16px 0",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "var(--primary-color)",
                      }}
                    >
                      Marcas
                    </h3>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                      }}
                    >
                      {brands.map((item) => {
                        const { id, label, check } = item;
                        return (
                          <label
                            key={id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              cursor: "pointer",
                              fontSize: "14px",
                              color: "var(--light-color)",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={check}
                              onChange={() => onClickBrand(id)}
                              style={{ accentColor: "var(--primary-color)" }}
                            />
                            {label}
                          </label>
                        );
                      })}
                    </div>
                  </div>

                  <div
                    style={{
                      height: "1px",
                      backgroundColor: "#e0e0e0",
                      margin: "0 0 24px 0",
                    }}
                  />
                </>
              )}

            {["Categorias", "Produtos"].indexOf(target) >= 0 &&
              categories.length > 0 && (
                <>
                  <div style={{ marginBottom: "24px" }}>
                    <h3
                      style={{
                        margin: "0 0 16px 0",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "var(--primary-color)",
                      }}
                    >
                      Categorias
                    </h3>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                      }}
                    >
                      {categories.map((item) => {
                        const { id, label, check } = item;
                        return (
                          <label
                            key={id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              cursor: "pointer",
                              fontSize: "14px",
                              color: "var(--light-color)",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={check}
                              onChange={() => onClickCategory(id)}
                              style={{ accentColor: "var(--primary-color)" }}
                            />
                            {label}
                          </label>
                        );
                      })}
                    </div>
                  </div>
                </>
              )}
          </div>

          <div
            style={{
              padding: "20px",
              borderTop: "1px solid #e0e0e0",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <button
              onClick={handleApplyFilters}
              style={{
                backgroundColor: "var(--primary-color)",
                color: "white",
                border: "none",
                borderRadius: "8px",
                padding: "8px",
                fontSize: "14px",
                fontWeight: "600",
                textTransform: "uppercase",
                cursor: "pointer",
              }}
            >
              FILTRAR
            </button>

            <button
              onClick={handleClearFilter}
              style={{
                backgroundColor: "white",
                color: "var(--primary-color)",
                border: "1px solid var(--primary-color)",
                borderRadius: "8px",
                padding: "8px",
                fontSize: "14px",
                fontWeight: "600",
                textTransform: "uppercase",
                cursor: "pointer",
              }}
            >
              LIMPAR FILTRO
            </button>
          </div>
        </ModalApp>
      </>
    )
  );
}

FilterProducts.propTypes = {
  onClickCategory: PropTypes.func,
  onClickApplyFilter: PropTypes.func,
  onClickClearFilter: PropTypes.func,
  onClickBrand: PropTypes.func,
  target: PropTypes.string,
};
